<template>

  <t-page>


    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <template #title-buttons>

        <t-button
            @click="downloadReport(7, form.expeditionId, 'LAUDO_QUALIDADE_' + form.responseList.expeditionNumber)">
          <b-icon-file-earmark-check></b-icon-file-earmark-check>
          Laudo de Qualidade
        </t-button>

      </template>

      <template #default>

        <t-input v-model="form[fieldKey]" hidden/>

        <b-row>

          <t-input fixed highlight cols="4" v-model="form.qualityAppraisalCodeLabel" label="Nº Controle"/>

          <t-input fixed cols="4" v-model="form.responseList.expeditionNumber" label="Nº Expedição"/>

          <t-input fixed cols="4" number :decimals="2" v-model="form.responseList.totalProducedWeight"
                   label="Peso Certificado (Kg)"
                   help="Peso dos produtos que constam no certificado. Atualizado dinâmicamente"/>

        </b-row>

        <b-row>

          <t-input fixed cols="6" v-model="form.responseList.companyName" label="Cliente"/>

          <t-input fixed cols="6" v-model="form.responseList.customerCityFull" label="Cidade/UF"/>

        </b-row>

        <t-input fixed v-model="form.responseList.typeQualityAppraisal" label="Tipo de Certificado de Qualidade"
                 help="Para alteração é necessário alterar no cadastro do cliente, depois excluir o certificado e processar novamente gerando o PDF"/>

        <b-row>

          <t-input fixed cols="4" v-model="form.responseList.lotCodeLabel" label="Lote"/>

          <t-input fixed cols="4" v-model="form.responseList.groupProduct" label="Grupo"/>

          <t-input fixed cols="4" v-model="form.responseList.model" label="Modelo"/>

        </b-row>


        <b-row>

          <t-input cols="4" v-model="form.pageCurrent" required label="Página"
                   help="Nº da página em relação ao total de páginas que compoem o certificado dentro da mesma Expedição"/>

          <t-input cols="4" v-model="form.pageTotal" required label="Total"/>

          <t-input cols="4" v-model="form.issueDate" required date label="Data de Emissão"/>


        </b-row>

        <b-row>

          <t-input cols="6" v-model="form.responsavelName" fixed
                   help="Será obrigatóriamente o mesmo usuário que gerar ou atualizar o certificado"
                   label="Responsável - Técnico"/>
          <t-input cols="6" v-model="form.responsavelCRQ" label="Responsável - CRQ"/>

        </b-row>

        <div v-if="form.modelId === 72">

          <t-form-card title="Dados de Resultado Peletizados" class="mt-2">

            <b-row>

              <t-input cols="6" v-model="form.adsorcaoIodo" accept-zero number decimals="2"
                       label="Absorção de Iodo (g/Kg)"/>
              <t-input cols="6" v-model="form.absorcaoOleo" accept-zero number decimals="2"
                       label="Absorção de Óleo (ml/100g)"/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.teorResiduos325mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos  325 mesh (ppm)"/>
              <t-input cols="6" v-model="form.teorResiduos35mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos  35 mesh (ppm)"/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.teorUmidade" accept-zero number decimals="2"
                       label="Teor de Umidade (%)"/>

              <t-input cols="6" v-model="form.teorCinzas" accept-zero number decimals="2"
                       label="Teor de Cinzas (%)"/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.teorAtrito" accept-zero number decimals="2"
                       label="Teor de Atrito (%)"/>

              <t-input cols="6" v-model="form.teorFinos" accept-zero number decimals="2"
                       label="Teor de Finos (%)"/>


            </b-row>

            <t-msg info>Campos abaixo, serão exibidos somente para layouts especiais de certificados.</t-msg>

            <b-row>

              <t-input cols="6" v-model="form.transmitancia" accept-zero number decimals="2"
                       label="Transmitância (%)"/>

            </b-row>
            <b-row>

              <t-input cols="6" v-model="form.densidadePeletizado" number
                       decimals="2"
                       label="Densidade Aparente (Kg/m³)"/>

              <t-input cols="6" v-model="form.durezaGraosMedia5Maiores" number
                       decimals="2"
                       label="Dureza de Grãos (Média 5> Maiores)"/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.durezaGraos" number
                       decimals="2"
                       label="Dureza de Grãos (%)"/>

              <t-input cols="6" v-model="form.ph" number
                       decimals="2"
                       label="pH"/>


            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.areaNSA" number
                       decimals="2"
                       label="Área Superficial NSA m²/g"/>

              <t-input cols="6" v-model="form.areaSTSA" number
                       decimals="2"
                       label="Área Superficial STSA m²/g"/>

            </b-row>

          </t-form-card>

          <t-form-card title="Tolerância Peletizados" class="mt-2">

            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinTeorUmidade" accept-zero number decimals="2"
                       label="Teor de Umidade - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorUmidade" accept-zero number decimals="2"
                       label="Teor de Umidade - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinAdsorcaoIodo" accept-zero number decimals="2"
                       label="Absorção de Iodo - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxAdsorcaoIodo" accept-zero number decimals="2"
                       label="Absorção de Iodo - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinAbsorcaoOleo" accept-zero number decimals="2"
                       label="Absorção de Óleo - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxAbsorcaoOleo" accept-zero number decimals="2"
                       label="Absorção de Óleo - Max."/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinTransmitancia" accept-zero number decimals="2"
                       label="Transmitância - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTransmitancia" accept-zero number decimals="2"
                       label="Transmitância - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinTeorResiduos35mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos 35 mesh - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorResiduos35mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos 35 mesh - Max."/>

            </b-row>


            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinTeorResiduos325mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos 325 mesh - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorResiduos325mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos 325 mesh - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinTeorFinos" accept-zero number decimals="2"
                       label="Teor de Finos - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorFinos" accept-zero number decimals="2"
                       label="Teor de Finos - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinTeorAtrito" accept-zero number decimals="2"
                       label="Teor de Atrito - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorAtrito" accept-zero number decimals="2"
                       label="Teor de Atrito - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinTeorCinzas" accept-zero number decimals="2"
                       label="Teor de Cinzas - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorCinzas" accept-zero number decimals="2"
                       label="Teor de Cinzas - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinDurezaGraos" accept-zero number decimals="2"
                       label="Dureza Graos - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxDurezaGraos" accept-zero number decimals="2"
                       label="Dureza Graos - Max."/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinPh" accept-zero number decimals="2"
                       label="pH - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxPh" accept-zero number decimals="2"
                       label="pH - Max."/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinAreaNSA" accept-zero number decimals="2"
                       label="Área Superficial NSA - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxAreaNSA" accept-zero number decimals="2"
                       label="Área Superficial NSA - Max."/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinAreaSTSA" accept-zero number decimals="2"
                       label="Área Superficial STSA - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxAreaSTSA" accept-zero number decimals="2"
                       label="Área Superficial STSA - Max."/>

            </b-row>


            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinDensidadePeletizado" accept-zero number decimals="2"
                       label="Densidade Aparente - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxDensidadePeletizado" accept-zero number decimals="2"
                       label="Densidade Aparente - Max."/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinDurezaGraosMedia5Maiores" accept-zero number decimals="2"
                       label="Dureza Grãos (Média 5>Maiores) - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxDurezaGraosMedia5Maiores" accept-zero number decimals="2"
                       label="Dureza Grãos (Média 5>Maiores) - Max."/>

            </b-row>


          </t-form-card>

        </div>

        <div v-if="form.modelId === 67">

          <t-form-card title="Dados de Resultado Pó" class="mt-2">


            <b-row>

              <t-input cols="6" v-model="form.transmitancia" accept-zero number decimals="2"
                       label="Transmitância (%)"/>
              <t-input cols="6" v-model="form.teorAco" accept-zero number decimals="4"
                       label="Teor de Aço (ppm)"/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.densidadePo" accept-zero number decimals="2"
                       label="Densidade pó kg/m³"/>
              <t-input cols="6" v-model="form.retido500" accept-zero number decimals="2"
                       label="Retido #500 (%) pó"/>

            </b-row>


            <b-row>

              <t-input cols="6" v-model="form.teorResiduos325mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos  325 mesh (ppm)"/>
              <t-input cols="6" v-model="form.teorResiduos35mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos  35 mesh (ppm)"/>

            </b-row>


            <b-row>

              <t-input cols="6" v-model="form.adsorcaoIodo" accept-zero number decimals="2"
                       label="Absorção de Iodo (g/Kg)"/>
              <t-input cols="6" v-model="form.absorcaoOleo" accept-zero number decimals="2"
                       label="Absorção de Óleo (ml/100g)"/>

            </b-row>


            <b-row>

              <t-input cols="6" v-model="form.teorUmidade" accept-zero number decimals="2"
                       label="Teor de Umidade (%)"/>

              <t-input cols="6" v-model="form.teorCinzas" accept-zero number decimals="2"
                       label="Teor de Cinzas (%)"/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.ph" number
                       decimals="2"
                       label="pH"/>

            </b-row>


          </t-form-card>

          <t-form-card title="Tolerância Pó" class="mt-2">


            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinTransmitancia" accept-zero number decimals="2"
                       label="Transmitância - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTransmitancia" accept-zero number decimals="2"
                       label="Transmitância - Max."/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinTeorAco" accept-zero number decimals="2"
                       label="Teor de Aço - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorAco" accept-zero number decimals="2"
                       label="Teor de Aço - Max."/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinDensidadePo" accept-zero number decimals="2"
                       label="Densidade pó - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxDensidadePo" accept-zero number decimals="2"
                       label="Densidade pó - Max."/>

            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinRetido500" accept-zero number decimals="2"
                       label="Retido #500 - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxRetido500" accept-zero number decimals="2"
                       label="Retido #500 - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinTeorResiduos35mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos 35 mesh - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorResiduos35mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos 35 mesh - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinTeorResiduos325mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos 325 mesh - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorResiduos325mesh" accept-zero number decimals="4"
                       label="Teor de Resíduos 325 mesh - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinAdsorcaoIodo" accept-zero number decimals="2"
                       label="Absorção de Iodo - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxAdsorcaoIodo" accept-zero number decimals="2"
                       label="Absorção de Iodo - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinAbsorcaoOleo" accept-zero number decimals="2"
                       label="Absorção de Óleo - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxAbsorcaoOleo" accept-zero number decimals="2"
                       label="Absorção de Óleo - Max."/>

            </b-row>


            <b-row>

              <t-input cols="6" v-model="form.toleranciaMinTeorUmidade" accept-zero number decimals="2"
                       label="Teor de Umidade - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorUmidade" accept-zero number decimals="2"
                       label="Teor de Umidade - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinTeorCinzas" accept-zero number decimals="2"
                       label="Teor de Cinzas - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxTeorCinzas" accept-zero number decimals="2"
                       label="Teor de Cinzas - Max."/>

            </b-row>

            <b-row>
              <t-input cols="6" v-model="form.toleranciaMinPh" accept-zero number decimals="2"
                       label="pH - Mín."/>

              <t-input cols="6" v-model="form.toleranciaMaxPh" accept-zero number decimals="2"
                       label="pH - Max."/>

            </b-row>

          </t-form-card>

        </div>


        <b-row>

          <t-input cols="6" v-model="form.logControl.createdUser" label="Usuário Criação" fixed/>
          <t-input cols="6" v-model="form.logControl.createdDate" label="Data Criação" fixed datetime/>

        </b-row>

        <b-row>

          <t-input cols="6" v-model="form.logControl.updatedUser" label="Usuário Modificação" fixed/>
          <t-input cols="6" v-model="form.logControl.updatedDate" label="Data Modificação" fixed datetime/>

        </b-row>


        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>


      </template>


    </t-page-form>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'PolimixQualityAppraisalForm',
  data() {
    return {
      path: "custom/polimix/quality-appraisal", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "qualityAppraisalId",
      enableGeneralFields: false,
      form: {
        qualityAppraisalId: 0,
        qualityAppraisalNumber: 0,
        qualityAppraisalCodeLabel: "",
        lotId: 0,
        adsorcaoIodo: 0,
        absorcaoOleo: 0,
        issueDate: "",
        groupProductId: "",
        responsavelCRQ: "",
        responsavelName: "",
        teorCinzas: 0,
        teorAtrito: 0,
        teorFinos: 0,
        teorUmidade: 0,
        teorResiduos325mesh: 0,
        teorResiduos35mesh: 0,
        durezaGraos: 0,
        ph: 0,
        retido500: 0,
        transmitancia: 0,
        teorAco: 0,
        densidadePo: 0,
        areaNSA: 0,
        areaSTSA: 0,
        densidadePeletizado: 0,
        durezaGraosMedia5Maiores: 0,
        toleranciaMinAdsorcaoIodo: 0,
        toleranciaMinAbsorcaoOleo: 0,
        toleranciaMinDurezaGraos: 0,
        toleranciaMinTeorCinzas: 0,
        toleranciaMinTeorResiduos325mesh: 0,
        toleranciaMinTeorResiduos35mesh: 0,
        toleranciaMinTeorUmidade: 0,
        toleranciaMinTeorFinos: 0,
        toleranciaMinTeorAtrito: 0,
        toleranciaMinPh: 0,
        toleranciaMinRetido500: 0,
        toleranciaMinTransmitancia: 0,
        toleranciaMinTeorAco: 0,
        toleranciaMinDensidadePo: 0,
        toleranciaMinAreaNSA: 0,
        toleranciaMinAreaSTSA: 0,
        toleranciaMaxAdsorcaoIodo: 0,
        toleranciaMaxAbsorcaoOleo: 0,
        toleranciaMaxDurezaGraos: 0,
        toleranciaMaxTeorCinzas: 0,
        toleranciaMaxTeorResiduos325mesh: 0,
        toleranciaMaxTeorResiduos35mesh: 0,
        toleranciaMaxTeorUmidade: 0,
        toleranciaMaxTeorFinos: 0,
        toleranciaMaxTeorAtrito: 0,
        toleranciaMaxPh: 0,
        toleranciaMaxRetido500: 0,
        toleranciaMaxTransmitancia: 0,
        toleranciaMaxTeorAco: 0,
        toleranciaMaxDensidadePo: 0,
        toleranciaMaxAreaNSA: 0,
        toleranciaMaxAreaSTSA: 0,
        toleranciaMaxDensidadePeletizado: 0,
        toleranciaMaxDurezaGraosMedia5Maiores: 0,
        toleranciaMinDensidadePeletizado: 0,
        toleranciaMinDurezaGraosMedia5Maiores: 0,

        producedDate: "",
        producedDateEnd: "",
        responseList: {},
        logControl: {
          updatedUser: "",
          updatedDate: "",
        },
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend

      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },

    async mountedContinued() {

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>